import React from "react";

import { RequoteConsumer } from "../../context/quote-versioning-context";
import SlideOutModal from "../../components/SlideOutModal";

import Widget from "./Widget";

import "../../styles/requote-modal.scss";

const Requote = (props) => (
  <RequoteConsumer>
    {(contextState) => {
      if (contextState.showError) {
        contextState.closeRequote();
        props.showErrorMessage("Requote");
        contextState.showedErrorMessage();
      }

      if (contextState.reload) {
        contextState.closeRequote();
        props.hideLobDetails();
        props.reload();
        contextState.reloaded();
      }

      const buttons = [
        <button
          disabled={requoteRequestable(contextState.secondScreenWidgets)}
          className={"btn btn-primary float-right"}
          onClick={contextState.onHandleContinue}
        >
          Request Requote
        </button>,
        <button
          className="btn btn-default float-right mr-2"
          onClick={() => {
            contextState.closeRequote();
            props.hideLobDetails();
          }}
        >
          Cancel
        </button>,
      ];

      return (
        <SlideOutModal
          title={"Requote"}
          onClose={() => {
            contextState.closeRequote();
            props.hideLobDetails();
          }}
          buttons={buttons}
          className={"requote-modal"}
          width={800}
        >
          <div className="hint">
            Please complete the required form below for requote.
          </div>
          {contextState.secondScreenWidgets.map((widget) => {
            return (
              <Widget
                key={widget.WidgetId}
                {...widget}
                updateWidget={(id, value) =>
                  contextState.updateWidget(id, value, true)
                }
              />
            );
          })}
        </SlideOutModal>
      );
    }}
  </RequoteConsumer>
);

function requoteRequestable(secondScreenWidgets) {
  return secondScreenWidgets.some(
    (widget) => Object.keys(widget.ValidationMessages).length > 0
  );
}

export default Requote;
